import { PROD_WEB_WRAPPER_LINK } from '../../constants';

export const getIsDev = (type: 'replyBot' | 'localhost' | 'both' = 'both'): boolean => {
  const isLocalhost = import.meta.env.DEV;

  if (type === 'both' || type === 'localhost') return isLocalhost;

  if (type === 'replyBot') {
    return window.location.host !== PROD_WEB_WRAPPER_LINK;
  }

  return false;
};
